import { Builder } from "."
import { SocketSlice } from "./types"
// import { Viewer } from "@nova/constants"
import { getAllWorkspaces } from "features/data-management/workspace/WorkspaceManagementSlice"

export default {
    handlers: (builder: Builder) =>
        builder.addCase(getAllWorkspaces.fulfilled, (_, action, socket) => {
            const { organizations } = action.payload
            organizations.forEach((item: { id: string }) => {
                socket.emit("subscribe", item.id, "org")
            })
        }),
    // events: {
    //     org: (store) => (orgId: string, user: Viewer) => {
    //         store.dispatch(addViewerToWorkspace({ user, orgId }))
    //     },
    //     leaveorg: (store) => (orgId: string, user: Viewer) => {
    //         store.dispatch(removeViewerFromWorkspace({ user, orgId }))
    //     },
    // },
} as SocketSlice
